import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { MessageSquare } from 'lucide-react';
import { useChatPanel } from '@/contexts/ChatPanelContext';
import { useChannels } from '@/hooks/useChat';
import { useAuth } from '@/contexts/AuthContext';

export function ChatToggleButton() {
  const { isOpen, toggleChat } = useChatPanel();
  const { isAuthenticated } = useAuth();
  const { data: channels } = useChannels();

  // Count unread channels
  const unreadCount = isAuthenticated && channels 
    ? channels.filter(channel => channel.hasUnread).length 
    : 0;

  if (!isAuthenticated) return null;

  // Hide the toggle button when panel is open (panel has its own X to close)
  if (isOpen) return null;

  return (
    <Button
      onClick={toggleChat}
      variant="outline"
      size="icon"
      className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-40 transition-all duration-300 hover:scale-110 bg-white/80 dark:bg-background/80 backdrop-blur-sm hover:bg-white dark:hover:bg-background"
    >
      <MessageSquare className="h-6 w-6" />
      {unreadCount > 0 && (
        <Badge 
          variant="destructive" 
          className="absolute -top-1 -right-1 h-6 min-w-6 flex items-center justify-center p-0 rounded-full text-xs"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </Badge>
      )}
    </Button>
  );
}
